import styled from '@emotion/styled';

export const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  --placeholder-color-0: var(--background-accent-gray-subtlest);
  --placeholder-color-50: var(--background-accent-gray-subtler);
  --placeholder-color-100: var(--background-accent-gray-subtlest);
`;

export const DashboardBody = styled.div`
  display: flex;
  height: 100%;
  min-height: 200px;
`;

export const DashboardSidebar = styled.div`
  flex: 1 1 50%;
  max-width: 300px;
  padding: 15px 10px 15px 10px;
  border-right: 1px solid var(--border) !important;
`;

export const DashboardMain = styled.div`
  margin-top: 10px;
  flex: 1 0 50%;
  display: flex;
  flex-direction: column;
  max-width: 850px;
`;
